import { useAuth } from '../contexts/AuthContext'
import { LogOut } from 'lucide-react'

const colors = {
  primary: '#FF4D00',
  surface: '#FFFFFF',
  text: '#1A1A1A',
}

const fonts = {
  body: '"Inter", system-ui, sans-serif',
}

function ImpersonationBar() {
  const { isImpersonating, user, stopImpersonation } = useAuth()

  if (!isImpersonating) return null

  return (
    <div
      style={{
        backgroundColor: colors.primary,
        color: colors.surface,
        padding: '10px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
        fontFamily: fonts.body,
        fontSize: '14px',
        fontWeight: 500,
        zIndex: 40,
        position: 'relative',
      }}
    >
      <span>
        Viewing as <strong>{user?.display_name || user?.username || 'User'}</strong>. Return to admin view.
      </span>
      <button
        onClick={stopImpersonation}
        style={{
          backgroundColor: colors.surface,
          color: colors.primary,
          border: 'none',
          borderRadius: '4px',
          padding: '6px 12px',
          fontSize: '13px',
          fontWeight: 600,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          fontFamily: fonts.body,
        }}
      >
        <LogOut size={14} />
        Stop Impersonating
      </button>
    </div>
  )
}

export default ImpersonationBar
